// Single source of truth for the brand's hex color values, mirroring
// client/tailwind.config.js. Tailwind classes (bg-primary, text-secondary,
// etc.) should always be preferred in component JSX — this file exists only
// for the handful of places that can't use Tailwind classes directly
// (inline SVG data URIs, Leaflet pathOptions, etc.) and previously had these
// same hex values copy-pasted and drifting out of sync.
const BRAND_COLORS = {
  surface: '#fbf9f5',
  white: '#ffffff',
  primary: '#4f645b',
  primaryDim: '#43574f',
  primaryContainer: '#d4e8df',
  secondary: '#7d5458',
  secondaryDim: '#70484c',
  secondaryContainer: '#f5d8da',
  tertiary: '#685e4f',
  tertiaryDim: '#5b5243',
  tertiaryContainer: '#efe4d2',
  // Fourth brand tone (see tailwind.config.js `accent`), used for the
  // Resources hub's NZ Support & Money section accent theming.
  accent: '#4a6fa5',
  accentDim: '#3d5c87',
  accentContainer: '#dce6f5',
  error: '#ac3434',
  outline: '#7a7a72',
  outlineVariant: '#c5c5bc',
};

export default BRAND_COLORS;
